/**
 * A1 Notation Utilities
 * Convert between 0-based indices and Excel A1 notation
 */

/**
 * Convert 0-based column index to Excel column letters (A, B, ..., Z, AA, AB, ...)
 * @param colIndex0 - 0-based column index (0 = A, 25 = Z, 26 = AA)
 * @returns Excel column letters
 */
export function colToLetters(colIndex0: number): string {
  // Convert to 1-based for calculation
  let n = colIndex0 + 1;
  let s = "";
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

/**
 * Convert 0-based row and column indices to Excel A1 notation
 * @param rowIndex0 - 0-based row index (0 = row 1)
 * @param colIndex0 - 0-based column index (0 = column A)
 * @returns Excel A1 notation (e.g., "A1", "Z1", "AA100")
 */
export function toA1(rowIndex0: number, colIndex0: number): string {
  const col = colToLetters(colIndex0);
  const row = rowIndex0 + 1; // Convert to 1-based row number
  return col + row;
}
